import React from 'react';
import styled from 'styled-components';

const BlogHomePage = () => {
  const blogs = [
    {
      title: "Ceriatric Doctors: Who They Are and What They Do",
      author: "admin",
      date: "Nov 20, 2025",
      category: "Geriatric Healthcare"
    },
    {
      title: "Understanding Endocrine Surgery: Risks & Types",
      author: "admin",
      date: "Nov 20, 2025",
      category: "Endocrine Surgery"
    },
    {
      title: "Hyperslipidemia: Know About Its Causes and Symptoms",
      author: "admin",
      date: "Nov 20, 2025",
      category: "Cardiac Sciences"
    },
    {
      title: "Understanding Orthodontics: Its Role in Dental Health and Treatment Options",
      author: "admin",
      date: "Nov 20, 2025",
      category: "Dental Science"
    },
    {
      title: "Why Winter Puts Extra Stress on Your Heart — and How to Stay Safe",
      author: "Dr. Covitham H C",
      date: "Nov 18, 2025",
      category: "Cardiac Sciences"
    },
    {
      title: "Nutrition & Lifestyle Tips for Breast Cancer Patients During Treatment",
      author: "Dr. Suhail Qureshi",
      date: "Nov 12, 2025",
      category: "Oncology"
    },
    {
      title: "Endocrine Surgery: Tests and Procedures Explained",
      author: "admin",
      date: "Nov 20, 2025",
      category: "Endocrine Surgery"
    },
    {
      title: "Nutraceuticals: Bridging Food and Medicine",
      author: "admin",
      date: "Nov 20, 2025",
      category: "General Surgery"
    },
    {
      title: "Stroke Rehabilitation: Enhancing Recovery and Quality of Life for Survivors",
      author: "admin",
      date: "Nov 20, 2025",
      category: "Neurology"
    },
    {
      title: "What Is Fibromyalgia: Symptoms and Its Diagnosis",
      author: "admin",
      date: "Nov 20, 2025",
      category: "Rheumatology"
    },
    {
      title: "Rheumatoid Toe Deformities: Walk the Very Next Day",
      author: "Dr. Chandan",
      date: "Nov 18, 2025",
      category: "Rheumatology"
    },
    {
      title: "Is Knee Pain Affecting Your Daily Life? Here's What You Need to Know",
      author: "Dr. Amtie Pankaj Aggarwal",
      date: "Nov 10, 2025",
      category: "Orthopaedics"
    },
    {
      title: "Top 5 Myths About Knee Replacement Surgery Debunked",
      author: "Dr. Amtie Pankaj Aggarwal",
      date: "Oct 30, 2025",
      category: "Orthopaedics"
    }
  ];

  const categories = [
    "Cardiac Sciences", "Ophthalmology", "Paediatrics", "Emergency and Trauma", 
    "Oncology", "Nephrology", "Orthopaedics", "Neurology", "Support Specialties", 
    "Internal Medicine", "Fetal Medicine", "Vascular Surgery", 
    "Neurointerventional Radiology", "Urology", "ENT", "Obstetrics and Gynaecology",
    "Gastroenterology and Hepatobiliary Sciences", "Dermatology", 
    "Diabetology/Endocrinology", "Pulmonology", "Haematology", "Rheumatology",
    "Neurosurgery", "Plastic and Reconstructive Surgery", "Organ Transplant",
    "Dental Science", "Radiology", "General Surgery", "Infectious Diseases",
    "Endocrine Surgery", "Gastroenterology", "General Physician", 
    "Haematology and BMT", "Liver Transplant", "Dietetics and Clinical Nutrition",
    "Metabolic & Bariatric Surgery", "ENT (Ear, Nose and Throat)", 
    "Intensive Care and Critical Care", "Orthopaedics and Joint Replacement",
    "Liver Transplant and Hepatobiliary Sciences", "Infertility medicine",
    "Pain and Palliative Medicine", "Medical Genetics", "Vascular Surgery"
  ];

  return (
    <PageContainer>
      <Header>
        <PageTitle>Blogs</PageTitle>
      </Header>
      
      <ContentWrapper>
        <MainContent>
          {blogs.map((blog, index) => (
            <BlogCard key={index}>
              <BlogTitle>{blog.title}</BlogTitle>
              <BlogMeta>
                {blog.author} | {blog.date}
              </BlogMeta>
              {blog.category && (
                <BlogCategory>{blog.category}</BlogCategory>
              )}
            </BlogCard>
          ))}
          
          <Pagination>
            <PageNumbers>
              {[2, 3, 4, 5, 6, 7, 8, 9].map(page => (
                <PageNumber key={page} active={page === 2}>
                  {page}
                </PageNumber>
              ))}
            </PageNumbers>
            <ResultsInfo>Showing results | - 10 of 2025</ResultsInfo>
          </Pagination>
        </MainContent>
        
        <Sidebar>
          <SidebarSection>
            <SidebarTitle>Popular Blogs</SidebarTitle>
            <PopularBlog>
              <PopularBlogTitle>
                Nutrition & Lifestyle Tips for Breast Cancer Patients During Treatment
              </PopularBlogTitle>
              <BlogMeta>
                Dr. Suhail Qureshi | Nov 12, 2025
              </BlogMeta>
            </PopularBlog>
          </SidebarSection>
          
          <SidebarSection>
            <SidebarTitle>Categories</SidebarTitle>
            <CategoryList>
              {categories.map((category, index) => (
                <CategoryItem key={index}>
                  {category}
                </CategoryItem>
              ))}
            </CategoryList>
            <ApplyButton>Apply</ApplyButton>
          </SidebarSection>
        </Sidebar>
      </ContentWrapper>
    </PageContainer>
  );
};

// Styled Components
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  background-color: #f8f9fa;
`;

const Header = styled.div`
  margin-bottom: 30px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 15px;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: #2c3e50;
  margin: 0;
  font-weight: 600;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const BlogCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #3498db;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  }
`;

const BlogTitle = styled.h2`
  font-size: 1.4rem;
  color: #2c3e50;
  margin: 0 0 12px 0;
  line-height: 1.4;
  font-weight: 600;
`;

const BlogMeta = styled.div`
  color: #7f8c8d;
  font-size: 0.9rem;
  margin-bottom: 8px;
`;

const BlogCategory = styled.span`
  display: inline-block;
  background-color: #ecf0f1;
  color: #34495e;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 8px;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
`;

const PageNumbers = styled.div`
  display: flex;
  gap: 8px;
`;

const PageNumber = styled.button`
  padding: 8px 12px;
  border: 1px solid #bdc3c7;
  background-color: ${props => props.active ? '#3498db' : 'white'};
  color: ${props => props.active ? 'white' : '#2c3e50'};
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.active ? '#2980b9' : '#ecf0f1'};
  }
`;

const ResultsInfo = styled.div`
  color: #7f8c8d;
  font-size: 0.9rem;
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const SidebarSection = styled.div`
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const SidebarTitle = styled.h3`
  font-size: 1.3rem;
  color: #2c3e50;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #ecf0f1;
  font-weight: 600;
`;

const PopularBlog = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid #ecf0f1;

  &:last-child {
    border-bottom: none;
  }
`;

const PopularBlogTitle = styled.h4`
  font-size: 1rem;
  color: #2c3e50;
  margin: 0 0 8px 0;
  line-height: 1.4;
  font-weight: 500;
`;

const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 20px;
`;

const CategoryItem = styled.div`
  padding: 10px 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
  color: #34495e;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid #3498db;

  &:hover {
    background-color: #e3f2fd;
    transform: translateX(5px);
  }
`;

const ApplyButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #2980b9;
  }
`;

export default BlogHomePage;
